import { render, staticRenderFns } from "./trip_sheet_tbn.vue?vue&type=template&id=61820ab2&scoped=true&"
import script from "./trip_sheet_tbn.vue?vue&type=script&lang=js&"
export * from "./trip_sheet_tbn.vue?vue&type=script&lang=js&"
import style0 from "./trip_sheet_tbn.vue?vue&type=style&index=0&id=61820ab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61820ab2",
  null
  
)

export default component.exports